function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "orgRole");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu-copy",
  transform: "translate(-34.000000, -969.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "menu"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-5",
  transform: "translate(20.000000, 956.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "orgRole",
  transform: "translate(14.000000, 13.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.109375,2.15625 C14.109375,0.99309375 13.1631563,0 12,0 C10.8368437,0 9.890625,0.99309375 9.890625,2.15625 C9.890625,3.31940625 10.8368437,4.265625 12,4.265625 C13.1631562,4.265625 14.109375,3.31940625 14.109375,2.15625 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.515625,7.78125 C15.515625,5.84282812 13.9384219,4.265625 12,4.265625 C10.0615781,4.265625 8.484375,5.84282812 8.484375,7.78125 L8.484375,8.484375 L15.515625,8.484375 L15.515625,7.78125 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 20.4375,
  cy: 10.59375,
  r: 2.109375
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.4375,12.703125 C18.4990781,12.703125 16.921875,14.2803281 16.921875,16.21875 L16.921875,16.921875 L24,16.921875 L24,16.21875 C24,14.2803281 22.3759219,12.703125 20.4375,12.703125 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 3.5625,
  cy: 10.59375,
  r: 2.109375
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.078125,16.21875 C7.078125,14.2803281 5.50092188,12.703125 3.5625,12.703125 C1.62407812,12.703125 0,14.2803281 0,16.21875 L0,16.921875 L7.078125,16.921875 L7.078125,16.21875 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 12,
  cy: 17.625,
  r: 2.109375
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.515625,23.25 C15.515625,21.3115781 13.9384219,19.734375 12,19.734375 C10.0615781,19.734375 8.484375,21.3115781 8.484375,23.25 L8.484375,24 L15.515625,24 L15.515625,23.25 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.265625,6.375 C4.265625,5.21184375 5.21184375,4.265625 6.375,4.265625 L7.078125,4.265625 L7.078125,2.859375 L6.375,2.859375 C4.43657812,2.859375 2.859375,4.43657812 2.859375,6.375 L2.859375,7.078125 L4.265625,7.078125 L4.265625,6.375 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.734375,6.375 L19.734375,7.078125 L21.140625,7.078125 L21.140625,6.375 C21.140625,4.43657812 19.5634219,2.859375 17.625,2.859375 L16.921875,2.859375 L16.921875,4.265625 L17.625,4.265625 C18.7881563,4.265625 19.734375,5.21184375 19.734375,6.375 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.859375,18.328125 L2.859375,19.03125 C2.859375,20.9696719 4.43657812,22.546875 6.375,22.546875 L7.078125,22.546875 L7.078125,21.140625 L6.375,21.140625 C5.21184375,21.140625 4.265625,20.1944063 4.265625,19.03125 L4.265625,18.328125 L2.859375,18.328125 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.140625,19.03125 L21.140625,18.328125 L19.734375,18.328125 L19.734375,19.03125 C19.734375,20.1944063 18.7881563,21.140625 17.625,21.140625 L16.921875,21.140625 L16.921875,22.546875 L17.625,22.546875 C19.5634219,22.546875 21.140625,20.9696719 21.140625,19.03125 Z",
  id: "Path"
})))))));

const SvgOrgRole = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrgRole, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OrgRole.99aeaa11.svg";
export { ForwardRef as ReactComponent };